import { all } from 'redux-saga/effects';
import feeServiceWorker from './feeSaga';

export default function* rootSaga(action) {
	yield all([feeServiceWorker(action)]);
}
